export interface BillingCycleOption {
  label: string;
  value: string;
  start: Date;
  end: Date;
}

export const BILLING_CYCLE_OPTION_COUNT = 13;

export function buildBillingCycleOptions(
  newCycleDay: number,
  today: Date = new Date(),
  count = BILLING_CYCLE_OPTION_COUNT
): BillingCycleOption[] {
  const options: BillingCycleOption[] = [];
  let cycleStartDate = new Date(today.getFullYear(), today.getMonth(), newCycleDay);
  if (cycleStartDate > today) {
    cycleStartDate.setMonth(cycleStartDate.getMonth() - 1);
  }

  for (let i = 0; i < count; i++) {
    const nextMonth = new Date(cycleStartDate.getFullYear(), cycleStartDate.getMonth() + 1, newCycleDay);
    const cycleEndDate = new Date(nextMonth.getTime());
    cycleEndDate.setDate(cycleEndDate.getDate() - 1);
    const start = new Date(cycleStartDate.getTime());

    options.push({
      label: `${start.toLocaleDateString()} - ${cycleEndDate.toLocaleDateString()}`,
      value: start.toISOString(),
      start,
      end: cycleEndDate,
    });
    cycleStartDate.setMonth(cycleStartDate.getMonth() - 1);
  }

  return options;
}
